module.exports = __webpack_public_path__ + "images/external_images/img/20x20/black.jpg";